// extracted by mini-css-extract-plugin
export var arrowLeft = "RankRow-module--arrow-left--d0d9e";
export var arrowRight = "RankRow-module--arrow-right--19e1f";
export var counter = "RankRow-module--counter--d8e00";
export var highlightedRow = "RankRow-module--highlighted-row--8ad2b";
export var name = "RankRow-module--name--51c3e";
export var points = "RankRow-module--points--b9f6d";
export var rank = "RankRow-module--rank--e0269";
export var row = "RankRow-module--row--6bbdf";